import {useTranslation} from "react-i18next";
import FormFieldBox from "../../common/form/FormFieldBox";
import FormRow from "../../common/form/FormRow";
import React from "react";
import {Control} from "react-hook-form";
import FormCheckbox from "../../common/form/FormCheckbox";
import {UseFormGetFieldState, UseFormSetValue} from "react-hook-form/dist/types/form";

type Props = {
    index: number
    control: Control<any>
    setValue: UseFormSetValue<any>
    getFieldState: UseFormGetFieldState<any>
}


export const OptimizedFormTeamsForm = ({ index, control, setValue, getFieldState }: Props) => {
    const { t } = useTranslation()

    return (<FormRow>
        <FormFieldBox>
            <FormCheckbox
                label={t('users.edit.optimized-for-teams')}
                name={`fieldUpdates.${index}.values.0.selected`}
                control={control}
                setValue={setValue}
                getFieldState={getFieldState}
            />
        </FormFieldBox>
    </FormRow>)
}